import React from 'react';
import { PAYMENT_TYPE_LABELS } from '../../../constants';

const OrderDetailsPaymentForm = ({
  isEditMode,
  customerId,
  orders,
  isPaymentCompleted,
  newPaymentType,
  setNewPaymentType,
  newPaymentAmount,
  setNewPaymentAmount,
  isAddingPayment,
  handleAddPayment,
  isLoading
}) => {
  if (!(isEditMode && customerId && !customerId.startsWith('temp_') && orders.length > 0 && !isPaymentCompleted)) {
    return null;
  }

  return (
    <div className="payment-add-section">
      <h5><i className="fas fa-plus-circle"></i> Yeni Ödeme Ekle</h5>
      <div className="payment-add-form">
        <div className="payment-add-row">
          <div className="payment-type-select">
            <label>Ödeme Tipi:</label>
            <select
              value={newPaymentType}
              onChange={(e) => setNewPaymentType(e.target.value)}
              disabled={isAddingPayment}
            >
              {Object.entries(PAYMENT_TYPE_LABELS).map(([key, label]) => (
                <option key={key} value={key}>{label}</option>
              ))}
            </select>
          </div>
          <div className="payment-amount-input">
            <label>Tutar (₺):</label>
            <input
              type="number"
              step="0.01"
              min="0"
              value={newPaymentAmount}
              onChange={(e) => setNewPaymentAmount(e.target.value)}
              placeholder="0.00"
              disabled={isAddingPayment}
            />
          </div>
          <button
            type="button"
            onClick={handleAddPayment}
            className="payment-add-btn"
            disabled={isAddingPayment || isLoading || !newPaymentAmount}
          >
            {isAddingPayment ? (
              <i className="fas fa-spinner fa-spin"></i>
            ) : (
              <><i className="fas fa-plus"></i> Ekle</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsPaymentForm;
